import api from "../../services/api";

const useTicketNotes = () => {

    const saveNote = async (data) => {
        const { data: responseData } = await api.request({
            url: '/ticket-notes',
            method: 'POST',
            data
        });
        return responseData;
    }

    const deleteNote = async (id) => {
        const { data } = await api.request({
            url: `/ticket-notes/${id}`,
            method: 'DELETE'
        });
        return data;
    }

    const listNotes = async (params) => {
        // Validar se os parâmetros obrigatórios estão presentes
        if (!params || !params.ticketId || !params.contactId) {
            throw new Error('ticketId e contactId são obrigatórios para listar notas');
        }
        
        const { data } = await api.request({
            url: '/ticket-notes/list',
            method: 'GET',
            params
        });
        return data;
    }

    const getTicketHistory = async (ticketId, contactId) => {
        const { data } = await api.request({
            url: `/ticket-notes/history/${ticketId}/${contactId}`,
            method: 'GET'
        });
        return data;
    }

    return {
        saveNote,
        deleteNote,
        listNotes,
        getTicketHistory
    }
}

export default useTicketNotes;